import React, {PureComponent} from 'react';

import classNames from 'classnames';

import {ProgressBar, Step} from 'desktop/components/helpers/progressBar';

import s from './statusBar.scss';

type PropsType = {
    needPrescription?: boolean | null;
};

/**
 * Status bar for success page
 */
export class StatusBar extends PureComponent<PropsType> {
    static defaultProps = {
        needPrescription: false,
    };

    /**
     * Render component
     * @return {Node} component
     */
    render() {
        const {needPrescription} = this.props;
        return (
            <div className={s.container}>
                <ProgressBar activeStep={needPrescription ? 1 : 2}>
                    <Step
                        title={
                            <div className={classNames(s.stepTitle, s.email)}>
                                Confirmation email sent
                            </div>
                        }
                    />
                    <Step attention={needPrescription ?? false} type="small">
                        <div className={s.content}>
                            <h3 className={s.title}>We are waiting for your prescription</h3>
                            <span className={s.big}>
                                Production will start right after we receive it
                            </span>
                            <ul className={s.sendPrescription}>
                                <li className={s.upload}>
                                    Upload your prescription{' '}
                                    <a className={s.link} href="/contacts#status=1">
                                        here
                                    </a>
                                </li>
                                <li className={s.email}>
                                    Send it via email: prescription@glassesusa.com
                                </li>
                                <li className={s.fax}>Send it via fax: 1-888-250-6925</li>
                            </ul>
                        </div>
                    </Step>
                    <Step
                        title={
                            <div className={classNames(s.stepTitle, s.production)}>
                                In production
                            </div>
                        }
                    >
                        <div className={s.content}>
                            <h3 className={s.title}>
                                Please consider production time based on lens type
                            </h3>
                            <ul className={s.list}>
                                <li>Single vision - up to 3 business days</li>
                                <li>Multifocal - up to 6 business days</li>
                                <li>Non prescription - up to 2 business days</li>
                            </ul>
                        </div>
                    </Step>
                    <Step type="small" />
                    <Step
                        title={
                            <div className={classNames(s.stepTitle, s.shipping)}>
                                Shipping order
                            </div>
                        }
                    />
                    <Step type="small" />
                    <Step
                        title={
                            <div className={classNames(s.stepTitle, s.enjoy)}>
                                Enjoy your eyewear
                            </div>
                        }
                    />
                </ProgressBar>
            </div>
        );
    }
}
